import React, { PropsWithChildren, useEffect } from 'react';

import { useUserStore } from '@/hooks/use-user-store';
import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';

import { useModals } from '../hooks/use-modals';

/**
 * BottomSheetModalProvider that will dismiss all modals when the session expires.
 */
export const CustomBottomSheetModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { dismissAll } = useModals();

    useEffect(() => {
        return useUserStore.subscribe(state => {
            const expired = state.actions.sessionHasExpired();
            if (expired) {
                dismissAll();
            }
        });
    }, [dismissAll]);
    return <BottomSheetModalProvider>{children}</BottomSheetModalProvider>;
};
